import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, catchError, map } from 'rxjs';
import { staffRateHistoryRequestModel, staffRateHistoryResponseModel, staffRequestModel, staffResponseModel, staffTaskRatesResponseModel, teamResponseModel } from '../models/staff';
import { apiEndpoints } from 'src/app/shared/enums/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class StaffsService {

  userProfile = new Subject();
  private displayNameSource = new BehaviorSubject<string>('');
  currentDisplayName$ = this.displayNameSource.asObservable();

  private accessPermissionSubject = new BehaviorSubject<any>(null);
  accessPermission$: Observable<any> = this.accessPermissionSubject.asObservable();


  constructor(
    private httpClient: HttpClient
  ) { }

  staffList(page: number, limit: number, search_value: any): Observable<staffResponseModel> {
    return this.httpClient.get<staffResponseModel>(apiEndpoints.staff + `?page=${page}&limit=${limit}&search_value=${search_value}`).pipe(
      map((response: staffResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getStaffFilters(module: string): Observable<any> {
    return this.httpClient.get(apiEndpoints.get_user_organization_filter + `?module=${module}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  setStaffFilters(value: any): Observable<any> {
    return this.httpClient.post(apiEndpoints.set_user_organization_filter, value).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getStaff(staffId: any): Observable<staffResponseModel> {
    return this.httpClient.get<staffResponseModel>(apiEndpoints.staff + staffId + '/').pipe(
      map((response: staffResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  inviteStaff(staffRequest: staffRequestModel): Observable<staffResponseModel> {
    return this.httpClient.post<staffResponseModel>(apiEndpoints.staff, staffRequest).pipe(
      map((response: staffResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateStaff(staffId: any, staffRequest: staffRequestModel): Observable<staffResponseModel> {
    return this.httpClient.put<staffResponseModel>(apiEndpoints.staff + staffId + '/', staffRequest).pipe(
      map((response: staffResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteStaff(staffId: string, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.staff + staffId + '/', data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  //team

  teamList(page: number, limit: number, search_value: any): Observable<teamResponseModel> {
    return this.httpClient.get<teamResponseModel>(apiEndpoints.teamlist + `?page=${page}&limit=${limit}&search_value=${search_value}`).pipe(
      map((response: teamResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createTeam(teamRequest: any): Observable<teamResponseModel> {
    return this.httpClient.post<teamResponseModel>(apiEndpoints.teamlist, teamRequest).pipe(
      map((response: teamResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getTeam(teamId: any): Observable<teamResponseModel> {
    return this.httpClient.get<teamResponseModel>(apiEndpoints.teamlist + teamId + '/').pipe(
      map((response: teamResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateTeam(teamRequest: any, teamId: any): Observable<teamResponseModel> {
    return this.httpClient.put<teamResponseModel>(apiEndpoints.teamlist + teamId + '/', teamRequest).pipe(
      map((response: teamResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteTeam(teamId: string, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.teamlist + teamId + `/`, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  staffTaskRates(staff: number, page: number, limit: number): Observable<staffTaskRatesResponseModel> {
    return this.httpClient.get<staffTaskRatesResponseModel>(apiEndpoints.staff_task_rates + `?page=${page}&limit=${limit}&staff=${staff}`).pipe(
      map((response: staffTaskRatesResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  staffTaskCustomRates(data: any): Observable<staffTaskRatesResponseModel> {
    return this.httpClient.post<staffTaskRatesResponseModel>(apiEndpoints.staff_task_rates, data).pipe(
      map((response: staffTaskRatesResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  public uploadimage(file: File, name: any) {
    const formData = new FormData();
    formData.append('file', file, name);

    // return this.httpClient.post<any>('upload_view/profile_image/', formData).pipe(map(result => result));
    return this.httpClient.post<any>('upload_view/profile_image/', formData).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteUserProfile(data: any): Observable<any> {
    return this.httpClient.post<any>('delete_file/', data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  get_user_access_permission(id: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.user_access_permission + id + '/').pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong, Please try again later');
      })
    )
  }

  staff_access_permission(data: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.staff_access_permission, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  client_access_permission(data: any): Observable<any> {
    return this.httpClient.post<any>(apiEndpoints.client_access_permission, data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getStaffTaskRate(staff_id: string, page: any, limit: any): Observable<any[]> {
    return this.httpClient.get<any[]>(apiEndpoints.staff_task_billing_rates + `?staff_id=${staff_id}&page=${page}&limit=${limit}`).pipe(
      map((response: any[]) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateStaffTaskRate(data: any): Observable<any[]> {
    return this.httpClient.post<any[]>(apiEndpoints.staff_task_billing_rates, data).pipe(
      map((response: any[]) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateStaffRate(staff_id: any, postData: any): Observable<staffResponseModel> {
    return this.httpClient.patch<staffResponseModel>(apiEndpoints.staff + staff_id + `/`, postData).pipe(
      map((response: staffResponseModel) =>
        response
      ),
      catchError((error: staffResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getRateHistoryList(page: number, limit: number, staff_id: any): Observable<staffRateHistoryResponseModel> {
    return this.httpClient.get<staffRateHistoryResponseModel>(apiEndpoints.staff_rate_history + `?page=${page}&limit=${limit}&staff_id=${staff_id}`).pipe(
      map((response: staffRateHistoryResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createRateHistory(rate_history_request_model: staffRateHistoryRequestModel): Observable<staffRateHistoryResponseModel> {
    return this.httpClient.post<staffRateHistoryResponseModel>(apiEndpoints.staff_rate_history, rate_history_request_model).pipe(
      map((response: staffRateHistoryResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateRateHistory(rate_history_request_model: staffRateHistoryRequestModel, rate_history_id: string): Observable<staffRateHistoryResponseModel> {
    return this.httpClient.put<staffRateHistoryResponseModel>(apiEndpoints.staff_rate_history + rate_history_id + '/', rate_history_request_model).pipe(
      map((response: staffRateHistoryResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getstaffRateHistoryDetails(staff_rate_history_id: any): Observable<staffRateHistoryResponseModel> {
    return this.httpClient.get<staffRateHistoryResponseModel>(apiEndpoints.staff_rate_history + staff_rate_history_id + '/').pipe(
      map((response: staffRateHistoryResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  deleteStaffRateHistory(staff_rate_history_id: string, data: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.staff_rate_history + staff_rate_history_id + '/', data).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  multipleDeleteStaffRateHistory(staff_rate_history_id: any): Observable<any> {
    return this.httpClient.patch<any>(apiEndpoints.multiple_staff_history_delete, staff_rate_history_id).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  setAccessPermission(data: any): void {
    this.accessPermissionSubject.next(data);
  }

  updateDisplayName(displayName: string) {
    this.displayNameSource.next(displayName);
  }

  staffDDl(): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.staff_ddl).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  exportStaffList(): Observable<staffResponseModel> {
    return this.httpClient.get<staffResponseModel>(apiEndpoints.staff).pipe(
      map((response: staffResponseModel) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    )
  }

  resendEmailInvitation(email: string | any): Observable<staffResponseModel> {
    return this.httpClient.post<staffResponseModel>(apiEndpoints.staff_resend_email_invitation, email).pipe(
      map((response: staffResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }
}
